import LegalBirdPageLoading from "../../ContentLoader/LegalBirdPageLoading";
import PageContentContainer from "../../Container/PageContentContainer";
import { ProductHeadline } from "../../PageHeadline/PageHeadline";
import { useCase } from "../../../provider/CaseProvider";
import CaseReferenceFile from "../../Case/CaseReferenceFile/CaseReferenceFile";
import _ from "lodash";
import { Box } from "@mui/material";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { useParams } from "react-router-dom";
import { ReferenceFile } from "../../../types/ReferenceFile";
import { useRegisterRefetchPageData } from "../../../hooks/useRegisterRefetchPageData.ts";

const CaseReferenceFilePage = () => {
  const { courtAppointmentId } = useParams();
  const { product, refreshCase } = useCase();
  const queryClient = useQueryClient();
  const referenceFilesUri = "reference_files";
  const referenceFilesFilters = { courtAppointmentId };
  const { data: referenceFiles, isLoading } = useQuery({
    queryKey: queryKeys.collection(referenceFilesUri, referenceFilesFilters),
    queryFn: () => fetchCollection(referenceFilesUri, referenceFilesFilters),
    enabled: !!product
  });

  useRegisterRefetchPageData(() => {
    refreshCase();
    queryClient.invalidateQueries({
      queryKey: queryKeys.collection(referenceFilesUri, referenceFilesFilters),
    });
  });

  if (isLoading || !referenceFiles) {
    return <LegalBirdPageLoading />;
  }

  if (!product) {
    return null;
  }

  const referenceFile: undefined | ReferenceFile = _.head(referenceFiles["hydra:member"]);

  return (
    <>
      <PageContentContainer size={"small"}>
        <ProductHeadline title="Terminsvertreter-Handakte zu" product={product} />
        {!referenceFile ? (
          <Box sx={{ textAlign: "center" }}>Es gibt keine Handakte für diesen Termin</Box>
        ) : (
          <CaseReferenceFile
            product={product}
            referenceFile={referenceFile}
            refreshReferenceFile={() =>
              queryClient.invalidateQueries({
                queryKey: queryKeys.collection(referenceFilesUri, referenceFilesFilters)
              })
            }
          />
        )}
      </PageContentContainer>
    </>
  );
};

export default CaseReferenceFilePage;
